import { render } from "./InventoryDetails.vue?vue&type=template&id=5ce74f56&scoped=true"
import script from "./InventoryDetails.vue?vue&type=script&lang=js"
export * from "./InventoryDetails.vue?vue&type=script&lang=js"

import "./InventoryDetails.vue?vue&type=style&index=0&id=5ce74f56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce74f56"]])

export default __exports__